import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { formatRoute } from 'src/lib/routing';
import { ROUTES } from 'src/routes';

import { useStyles } from './useStyles';

export const Upgrade = ({ onBenchmarkUpgradeClick }) => {
  const styles = useStyles();

  const handleUpgradeClick = () => {
    onBenchmarkUpgradeClick();
    window.open(formatRoute(ROUTES.UPGRADE));
  };

  return (
    <div className={styles.root}>
      <CustomTypography
        className={styles.upgradeText}
        variant={TYPOGRAPHY_VARIANT.paragraph12}
      >
        The text is only compared to 50 copy assets that are supported by your starter subscription.
        To benchmark this text against all of your data,{' '}
        <span onClick={handleUpgradeClick}>upgrade to a higher tier.</span>
      </CustomTypography>
    </div>
  );
};

Upgrade.propTypes = {
  onBenchmarkUpgradeClick: PropTypes.func.isRequired,
};
Upgrade.defaultProps = {};
